import _partition from '@teetsh/app/src/utils/arrays/partition';

function getMatchingNiveau<P>(
  niveau: string,
  classrooms: P[],
  classroomNameAccessor: (v: P) => string,
) {
  return _partition(
    classrooms,
    cl =>
      classroomNameAccessor(cl).toLowerCase().startsWith(niveau) &&
      classroomNameAccessor(cl).length < 14,
  );
}

export function orderByNiveau<P>(
  classrooms: P[],
  accessor?: (v: P) => string,
): P[] {
  const identity = (v: P) => v as unknown as string;
  const classroomNameAccessor = accessor || identity;
  const { result, remaining } = [
    'sans groupe',
    'tps',
    'ps',
    'ms',
    'gs',
    'cp',
    'ce1',
    'ce2',
    'cm1',
    'cm2',
  ].reduce<{
    result: P[];
    remaining: P[];
  }>(
    (acc, num) => {
      const [matching, others] = getMatchingNiveau<P>(
        num,
        acc.remaining,
        classroomNameAccessor,
      );
      return {
        result: [...acc.result, ...matching.sort()],
        remaining: others.sort(),
      };
    },
    {
      remaining: classrooms,
      result: [],
    },
  );
  return [...result, ...remaining];
}
